import * as leaflet from "leaflet";
import { Path } from "../../lib/runescape/pathing";
import { util } from "../../lib/util/util";
import Behaviour from "../../lib/ui/Behaviour";
import { Transportation } from "../../lib/runescape/transportation";
import { GameLayer } from "../../lib/gamemap/GameLayer";
import { DrawAbilityInteraction } from "./interactions/DrawAbilityInteraction";
import PathEditActionBar from "./PathEditActionBar";
import { InteractionGuard } from "../../lib/gamemap/interaction/InteractionLayer";
import { TileCoordinates } from "../../lib/runescape/coordinates";
import assert from "assert";
import PlaceRedClickInteraction from "./interactions/PlaceRedClickInteraction";
import { SelectTileInteraction } from "../../lib/gamemap/interaction/SelectTileInteraction";
import InteractionTopControl from "../ui/map/InteractionTopControl";
import DrawRunInteraction from "./interactions/DrawRunInteraction";
import { direction, MovementAbilities, PathFinder } from "../../lib/runescape/movement";
import { PathStepEntity } from "../ui/map/entities/PathStepEntity";
import TransportLayer from "../ui/map/TransportLayer";
import { TileArea } from "../../lib/runescape/coordinates/TileArea";
import { CursorType } from "../../lib/runescape/CursorType";
import { TeleportSpotEntity } from "../ui/map/entities/TeleportSpotEntity";
import { EntityTransportEntity } from "../ui/map/entities/EntityTransportEntity";
import { GameMapControl } from "../../lib/gamemap/GameMapControl";
import { StepEditModal } from "./StepEditModal";
import { BookmarkStorage } from "./BookmarkStorage";
import { C } from "../../lib/ui/constructors";
import { TeleportAccessEntity } from "../ui/map/entities/TeleportAccessEntity";
import { TransportData } from "../../data/transports";
import { RemoteEntityTransportTarget } from "../ui/map/entities/RemoteEntityTransportTarget";
import { DrawCheatInteraction } from "./interactions/DrawCheatInteraction";
import { Notification } from "../ui/NotificationBar";
import { DrawCosmeticInteraction } from "./interactions/DrawCosmeticInteraction";
import { DrawTileAreaInteraction } from "../ui/devutilitylayer/DrawTileAreaInteraction";
import { DrawArrowInteraction } from "./interactions/DrawArrowInteraction";
import { PathGraphics } from "../ui/path_graphics";
import { EditedPathOverview } from "./EditedPathOverview";
import { PathEditorToolsControl } from "./PathEditorToolsControl";
import { PathBuilder } from "./PathBuilder";
import { PathEditMenuBar } from "./PathEditMenuBar";
var index = util.index;
var vbox = C.vbox;
var TeleportGroup = Transportation.TeleportGroup;
var resolveTeleport = TransportData.resolveTeleport;
var interactiveArea = Transportation.EntityAction.interactiveArea;
var EntityAction = Transportation.EntityAction;
var TeleportAccess = Transportation.TeleportGroup.TeleportAccess;
var notification = Notification.notification;
var arrow = PathGraphics.arrow;
var findAsync = util.findAsync;
import { ConfirmBeforeUnload } from "../../lib/util/ConfirmBeforeUnload";
import { PathOverlayControl } from "../overlay3d/PathOverlayControl";
import { HostedMapCollisionData } from "../../lib/runescape/CollisionData";
import { LeafletUtils } from "../../lib/gamemap/LeafletUtils";
import { LeafletPolygonConstructors } from "../../lib/gamemap/LeafletPolygonConstructors";
var areaPolygon = LeafletPolygonConstructors.areaPolygon;
var tilePolygon = LeafletPolygonConstructors.tilePolygon;
import { FakeLodash } from "../../lib/coreutil/FakeLodash";
function needRepairing(state, shortcut) {
    return state.position.tile
        && TileArea.activate(EntityAction.interactiveArea(shortcut.internal, shortcut.internal.actions[0]))
            .query(state.position.tile)
        && !TileCoordinates.eq2(state.position.tile, shortcut.assumed_start);
}
function repairShortcutStep(state, shortcut) {
    shortcut.assumed_start = state.position.tile;
}
class PathEditorGameLayer extends GameLayer {
    constructor(editor, add_transport_layer) {
        super();
        this.editor = editor;
        if (add_transport_layer)
            new TransportLayer(true).addTo(this);
    }
    eventContextMenu(event) {
        event.onPost(() => {
            if (this.editor.isActive()) {
                event.setTitle(`${event.tile().x} | ${event.tile().y} | ${event.tile().level}`);
                if (!event.active_entity) {
                    const current_tile = this.editor.value.cursor_state.value()?.state?.position?.tile;
                    const target_tile = event.tile();
                    if (current_tile && !TileCoordinates.eq2(current_tile, target_tile)) {
                        event.add({
                            type: "basic",
                            text: "Walk here",
                            icon: "/assets/icons/yellowclick.png",
                            handler: async () => {
                                const path_to_tile = await PathFinder.find(PathFinder.init_djikstra(this.editor.value.cursor_state.value().state.position.tile), TileArea.init(target_tile));
                                if (path_to_tile && path_to_tile.length > 1) {
                                    this.editor.value.add({
                                        type: "run",
                                        waypoints: path_to_tile,
                                    });
                                }
                                else {
                                    notification("No path found.", "error").show();
                                }
                            }
                        });
                    }
                    event.add({
                        type: "submenu",
                        text: "Redclick",
                        icon: "/assets/icons/cursor_redclick.png",
                        children: CursorType.all().map((i) => ({
                            type: "basic",
                            text: i.description,
                            icon: i.icon_url,
                            handler: () => {
                                this.editor.value.add({
                                    type: "redclick",
                                    target: CursorType.defaultEntity(i.type),
                                    where: event.tile(),
                                    how: i.type
                                });
                            }
                        }))
                    });
                }
                else if (event.active_entity instanceof TeleportSpotEntity) {
                    const t = event.active_entity.teleport;
                    if (t.group.access.length == 1) {
                        const a = t.group.access[0];
                        event.addForEntity({
                            type: "basic",
                            text: () => c().append(`Use via `, TeleportSpotEntity.accessNameAsWidget(a)),
                            handler: () => {
                                this.editor.value.add({
                                    type: "teleport",
                                    spot: t.centerOfTarget(),
                                    id: { ...t.id(), access: a.id },
                                });
                            }
                        });
                    }
                    else {
                        event.addForEntity({
                            type: "submenu",
                            text: `Use via`,
                            children: t.group.access.map(a => {
                                return {
                                    type: "basic",
                                    text: () => c().append(TeleportSpotEntity.accessNameAsWidget(a)),
                                    handler: () => {
                                        this.editor.value.add({
                                            type: "teleport",
                                            spot: t.centerOfTarget(),
                                            id: { ...t.id(), access: a.id },
                                        });
                                    }
                                };
                            })
                        });
                    }
                }
                else if (event.active_entity instanceof TeleportAccessEntity) {
                    const access = event.active_entity.access;
                    const teleport = event.active_entity.teleport;
                    event.addForEntity({
                        type: "submenu",
                        text: `Use action '${access.action_name}'`,
                        children: event.active_entity.teleport.spots.map(spot => {
                            const s = new TeleportGroup.Spot(teleport, spot, access);
                            return {
                                type: "basic",
                                icon: `assets/icons/teleports/${s.image().url}`,
                                text: s.code() ? `${spot.code}: ${spot.name}` : spot.name,
                                handler: async () => {
                                    const current_tile = this.editor.value.cursor_state.value().state?.position?.tile;
                                    const target = TeleportAccess.interactiveArea(access);
                                    const steps = [];
                                    if (current_tile && !TileArea.activate(target).query(current_tile)) {
                                        const path_to_start = await PathFinder.find(PathFinder.init_djikstra(current_tile), target);
                                        if (path_to_start && path_to_start.length > 1) {
                                            steps.push({
                                                type: "run",
                                                waypoints: path_to_start,
                                            });
                                        }
                                        else {
                                            notification("No path to transportation found.", "error").show();
                                        }
                                    }
                                    steps.push({
                                        type: "teleport",
                                        spot: s.centerOfTarget(),
                                        id: { ...s.id(), access: access.id },
                                    });
                                    this.editor.value.add(...steps);
                                }
                            };
                        }),
                    });
                }
                else if (event.active_entity instanceof EntityTransportEntity) {
                    let s = Transportation.normalize(event.active_entity.shortcut);
                    s.actions.forEach(a => {
                        event.addForEntity({
                            type: "basic",
                            text: `Use action '${a.name}'`,
                            icon: CursorType.meta(a.cursor).icon_url,
                            handler: async () => {
                                const current_tile = this.editor.value.cursor_state.value().state?.position?.tile;
                                let assumed_start = null;
                                const target = interactiveArea(s, a);
                                const steps = [];
                                if (current_tile) {
                                    if (TileArea.activate(target).query(current_tile))
                                        assumed_start = current_tile;
                                    else {
                                        const path_to_start = await PathFinder.find(PathFinder.init_djikstra(current_tile), target);
                                        if (path_to_start && path_to_start.length > 1) {
                                            assumed_start = index(path_to_start, -1);
                                            steps.push({
                                                type: "run",
                                                waypoints: path_to_start,
                                            });
                                        }
                                        else {
                                            notification("No path to transportation found.", "error").show();
                                        }
                                    }
                                }
                                assumed_start ?? (assumed_start = await findAsync(TileArea.activate(target).getTiles(), t => HostedMapCollisionData.get().isAccessible(t)));
                                let clone = FakeLodash.cloneDeep(s);
                                clone.actions = [FakeLodash.cloneDeep(a)];
                                this.editor.value.add(...steps, {
                                    type: "transport",
                                    assumed_start: assumed_start,
                                    internal: clone
                                });
                            }
                        });
                    });
                }
                else if (event.active_entity instanceof RemoteEntityTransportTarget) {
                }
                else if (event.active_entity instanceof PathStepEntity) {
                    const step = this.editor.value.committed_value.value().steps.find(v => v.associated_preview == event.active_entity);
                    if (step) {
                        event.addForEntity(...this.editor.contextMenu(step).children);
                    }
                }
            }
        });
    }
    eventKeyDown(event) {
        event.onPost(() => {
            const e = event.original;
            const handled = (() => {
                if (e.ctrlKey && e.key.toLowerCase() == "z") {
                    if (e.shiftKey) {
                        this.editor.value.undoredo.redo();
                    }
                    else {
                        this.editor.value.undoredo.undo();
                    }
                    return true;
                }
                else if (e.ctrlKey && e.key.toLowerCase() == "y") {
                    this.editor.value.undoredo.redo();
                    return true;
                }
                else if (e.ctrlKey && e.key.toLowerCase() == "s") {
                    this.editor.commit();
                    return true;
                }
                else if (e.key == "Backspace") {
                    this.editor.value.delete(this.editor.value.cursor - 1);
                    return true;
                }
                else if (e.key == "Delete") {
                    this.editor.value.delete(this.editor.value.cursor);
                    return true;
                }
                return false;
            })();
            if (handled) {
                event.stopAllPropagation();
                e.preventDefault();
            }
        });
    }
}
export class PathEditor extends Behaviour {
    constructor(game_layer, template_resolver, options, add_transport_layer) {
        super();
        this.game_layer = game_layer;
        this.template_resolver = template_resolver;
        this.options = options;
        this.control = null;
        this.handler_layer = null;
        this.overlay_control = null;
        this.you_are_here_marker = null;
        this.bookmarks = new BookmarkStorage();
        if (!options.start_state)
            options.start_state = Path.movement_state.start({});
        // Set up handler layer, but don't add it anywhere yet.
        this.handler_layer = new PathEditorGameLayer(this, add_transport_layer);
        this.value = new PathBuilder({
            target: this.options.target,
            start_state: FakeLodash.cloneDeep(this.options.start_state),
        }, options.initial);
        this.handler_layer.add(this.value.preview_layer);
        this.value.cursor_state.subscribe(({ state }) => {
            if (this.action_bar)
                this.action_bar.state.set(state);
            if (this.you_are_here_marker) {
                this.you_are_here_marker.remove();
                this.you_are_here_marker = null;
            }
            if (state.position.tile) {
                this.you_are_here_marker = leaflet.marker(LeafletUtils.latLongFromVector2(state.position.tile), {
                    icon: leaflet.icon({
                        iconUrl: "/assets/icons/youarehere.png",
                        iconSize: [25, 25],
                        iconAnchor: [13, 13],
                    })
                }).addTo(this.handler_layer);
            }
        });
        new GameMapControl({
            position: "left-top",
            type: "floating"
        }, vbox(new PathEditMenuBar(this), this.control = new EditedPathOverview(this))).addTo(this.handler_layer);
        this.overlay_control = new PathEditorToolsControl(this).addTo(this.handler_layer);
        this.interaction_guard = new InteractionGuard().setDefaultLayer(this.handler_layer);
        this.action_bar = new PathEditActionBar(this, this.interaction_guard).addTo(this.handler_layer);
        this.lifetime_manager.bind(ConfirmBeforeUnload.instance().register());
        this.ingame_overlay_control = this.withSub(new PathOverlayControl());
        this.value.committed_value.subscribe(v => {
            this.ingame_overlay_control.setIngameOverlays([v.path.raw]);
        });
    }
    begin() {
        this.handler_layer.addTo(this.game_layer);
        this.game_layer.getMap().container.focus();
        //const bounds = Rectangle.combine(Path.bounds(this.options.initial), Rectangle.from(this.options.start_state?.position?.tile), TileArea.toRect(this.options.target?.parent))
        if (this.options.target) {
            this.options.target.forEach(target => areaPolygon(target.parent).addTo(this.handler_layer));
        }
        //const level = this.options.target?.origin?.level ?? this.options.start_state?.position?.tile?.level ?? Math.min(...this.options.initial.map(Path.Step.level))
        // if (bounds) this.game_layer.getMap().fitView(TileRectangle.lift(bounds, level as floor_t), {maxZoom: 7})
    }
    end() {
        this.handler_layer.remove();
    }
    discard() {
        if (this.options.discard_handler) {
            this.options.discard_handler();
            this.stop();
        }
    }
    commit() {
        this.options.commit_handler?.(this.value.get());
    }
    close() {
        this.discard();
        this.stop();
    }
    editStep(value, interaction, hide_preview = true) {
        this.interaction_guard.set(interaction
            .onStart(() => {
            if (hide_preview)
                value.associated_preview?.setVisible(false);
            this.overlay_control.lens_layer.enabled2.set(false);
        })
            .onEnd(() => {
            if (hide_preview)
                value.associated_preview?.setVisible(true);
            else
                value.associated_preview?.render(true);
            this.overlay_control.lens_layer.enabled2.set(true);
        }));
    }
    async editStepDetails(value) {
        const result = await new StepEditModal(value.step.raw).do();
        if (result.new_version) {
            this.value.update(value.index, result.new_version);
        }
    }
    redrawAbility(value) {
        const v = value.step.raw;
        if (v.type == "ability") {
            this.editStep(value, new DrawAbilityInteraction(v.ability, this.value.assumptions())
                .setStartPosition(v.from)
                .onCommit(new_s => value.update(v => Object.assign(v, new_s))));
        }
        else if (v.type == "run") {
            this.editStep(value, new DrawRunInteraction()
                .setStartPosition(v.waypoints[0])
                .onCommit(new_s => value.update(v => Object.assign(v, new_s))));
        }
        else if (v.type == "cheat") {
            this.editStep(value, new DrawCheatInteraction(v.assumed_start)
                .onCommit(new_s => value.update(v => Object.assign(v, new_s))));
        }
    }
    moveStep(value) {
        const v = value.step;
        if (v.raw.type == "redclick") {
            this.editStep(value, new PlaceRedClickInteraction(v.raw.how)
                .onCommit(new_s => value.update((v) => {
                v.where = new_s.where;
            })));
        }
        else if (v.raw.type == "powerburst") {
            this.editStep(value, new SelectTileInteraction({
                preview_render: tile => new PathStepEntity({
                    type: "powerburst",
                    where: tile,
                })
            })
                .onCommit(new_s => value.update((v) => {
                v.where = new_s;
            }))
                .attachTopControl(new InteractionTopControl().setName("Selecting tile").setText(`Select the location of the powerburst by clicking the tile.`)));
        }
        else if (v.raw.type == "teleport") {
            const spot = resolveTeleport(v.raw.id);
            this.editStep(value, new SelectTileInteraction({
                preview_render: tile => {
                    assert(v.raw.type == "teleport");
                    if (TileArea.activate(spot.targetArea()).query(tile)) {
                        return new PathStepEntity({
                            type: "teleport",
                            id: v.raw.id,
                            spot: tile,
                        });
                    }
                    else {
                        return tilePolygon(tile)
                            .setStyle({
                            fillColor: "red",
                            color: "red",
                            stroke: true
                        });
                    }
                }
            })
                .addLayer(areaPolygon(spot.targetArea())
                .setStyle({
                fillColor: "lightgreen",
                color: "lightgreen",
                stroke: true
            }))
                .onCommit(new_s => value.update((v) => {
                v.spot = new_s;
            }))
                .attachTopControl(new InteractionTopControl().setName("Selecting tile").setText(`Select the specific target of the teleport by clicking the tile.`)));
        }
        else if (v.raw.type == "cosmetic") {
            this.editStep(value, new DrawCosmeticInteraction(v.raw)
                .onCommit(new_s => value.update((v) => {
                Object.assign(v, new_s);
            })));
        }
    }
    contextMenu(step) {
        const entries = [];
        const s = step.step.raw;
        entries.push({
            type: "basic",
            icon: "/assets/icons/edit.png",
            text: `Edit`,
            handler: () => this.editStepDetails(step)
        });
        entries.push({
            type: "basic",
            icon: "/assets/icons/delete.png",
            text: `Remove`,
            handler: () => step.delete()
        });
        if (step.step.raw.type == "ability" || step.step.raw.type == "run" || step.step.raw.type == "cheat") {
            entries.push({
                type: "basic",
                icon: "/assets/icons/edit.png",
                text: `Redraw on map`,
                handler: () => this.redrawAbility(step)
            });
        }
        if (step.step.raw.type == "powerburst" || step.step.raw.type == "redclick" || step.step.raw.type == "teleport" || step.step.raw.type == "cosmetic") {
            entries.push({
                type: "basic",
                icon: "/assets/icons/move.png",
                text: `Move on map`,
                handler: () => this.moveStep(step)
            });
        }
        if (step.step.raw.type == "orientation") {
            entries.push({
                type: "submenu",
                icon: "/assets/icons/compass.png",
                text: `Choose Direction`,
                children: direction.all.map(dir => ({
                    type: "basic",
                    text: direction.toString(dir),
                    handler: () => {
                        step.update((s) => s.direction = dir);
                    }
                }))
            });
        }
        if (step.step.raw.type == "cheat") {
            entries.push({
                type: "submenu",
                icon: "/assets/icons/Rotten_potato.png",
                text: "Choose Orientation",
                children: [undefined].concat(direction.all).map(dir => ({
                    type: "basic",
                    text: direction.toString(dir) ?? "None",
                    handler: () => {
                        step.update((s) => s.orientation = dir);
                    }
                }))
            });
        }
        if (step.step.raw.type == "redclick") {
            entries.push({
                type: "submenu",
                icon: "/assets/icons/cursor_redclick.png",
                text: `Choose Cursor`,
                children: CursorType.all().map(cursor => ({
                    type: "basic",
                    text: cursor.description,
                    icon: cursor.icon_url,
                    handler: () => {
                        step.update((s) => s.how = cursor.type);
                    }
                }))
            });
        }
        if ((s.type == "ability" && (s.ability == "dive" || s.ability == "barge")) || s.type == "run") {
            const color = s.type == "ability" ? PathStepEntity.ability_rendering[s.ability].color : PathStepEntity.run_rendering_area_color;
            entries.push({
                type: "basic",
                text: `Edit target area`,
                handler: () => {
                    this.editStep(step, new DrawTileAreaInteraction(s.target_area ? TileArea.activate(s.target_area).getTiles() : [])
                        .setPreviewFunction(tiles => leaflet.featureGroup(tiles.map(tile => tilePolygon(tile)
                        .setStyle({
                        color: color,
                        fillOpacity: 0.4,
                        stroke: false
                    }))))
                        .onPreview(tiles => {
                        s.target_area = tiles.length > 0 ? TileArea.fromTiles(tiles) : undefined;
                    }), false);
                }
            });
        }
        if (step.step.raw.type == "cosmetic") {
            const s = step.step.raw;
            entries.push({
                type: "basic",
                text: `Edit area`,
                handler: () => {
                    this.editStep(step, new DrawTileAreaInteraction(s.area ? TileArea.activate(s.area).getTiles() : [])
                        .setPreviewFunction(tiles => leaflet.featureGroup(tiles.map(tile => tilePolygon(tile)
                        .setStyle({
                        color: s.arrow_color ?? Path.COSMETIC_DEFAULT_COLORS.area,
                        fillOpacity: 0.4,
                        stroke: false
                    }))))
                        .onPreview(tiles => {
                        s.area = tiles.length > 0 ? TileArea.fromTiles(tiles) : undefined;
                    }));
                }
            });
            entries.push({
                type: "basic",
                text: `Edit arrow`,
                handler: () => {
                    this.editStep(step, new DrawArrowInteraction(true)
                        .setPreviewFunction(([from, to]) => arrow(from, to).setStyle({ weight: 4, color: s.arrow_color ?? Path.COSMETIC_DEFAULT_COLORS.arrow }))
                        .onCommit(tiles => {
                        s.arrow = tiles;
                    }));
                }
            });
        }
        return {
            type: "submenu",
            text: "",
            children: entries
        };
    }
}
(function (PathEditor) {
    var isFarDive = MovementAbilities.isFarDive;
    async function normalizeFarDive(step) {
        if (step.type != "ability")
            return step;
        if (step.ability != "dive")
            return step;
        return {
            ...step,
            is_far_dive: await isFarDive(step.from, step.to)
        };
    }
    PathEditor.normalizeFarDive = normalizeFarDive;
})(PathEditor || (PathEditor = {}));
